module.exports = __webpack_public_path__ + "img/kitkithandbookcover.3524b1ec.png";